<template>
  <div>
    <v-container>
      <v-row no-gutters align="center" justify="space-between">
        <h1 class="primary--text font-weight-bold pb-4">
          {{
            isRequestLandlord
              ? $t("landlord.requestLandlord")
              : $t("landlord.newlandlordRequest")
          }}
        </h1>
        <v-alert
          outlined
          text
          type="success"
          dense
          class="font-weight-bold"
          v-if="requestModelObj.isEnquiry"
        >
          Enquiry
        </v-alert>
      </v-row>
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form v-on:submit.prevent="handleSubmit(onSave)" :key="rerender">
          <v-row align="center">
            <v-col cols="12" sm="6" md="6" lg="6" class="py-0">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                  :error-messages="errors"
                  :disabled="true"
                  outlined
                  dense
                  :label="$t('landlord.name')"
                  type="text"
                  v-model="requestModelObj.name"
                >
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" class="py-0">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                  :error-messages="errors"
                  :disabled="true"
                  outlined
                  dense
                  :label="$t('landlord.lastName')"
                  type="text"
                  v-model="requestModelObj.lastName"
                >
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" class="py-0">
              <ValidationProvider v-slot="{ errors }" rules="required|email">
                <v-text-field
                  :error-messages="errors"
                  :disabled="true"
                  outlined
                  dense
                  :label="$t('landlord.email')"
                  type="text"
                  v-model="requestModelObj.email"
                >
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" class="py-0">
              <ValidationProvider
                v-slot="{ errors }"
                :rules="{ phone: 8, required: true }"
              >
                <v-text-field
                  :error-messages="errors"
                  :disabled="true"
                  outlined
                  class="numberClass"
                  dense
                  :label="$t('landlord.phoneNumber')"
                  type="number"
                  v-model="requestModelObj.phone"
                >
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" class="py-0">
              <ValidationProvider
                v-slot="{ errors }"
                :rules="{ required: true }"
              >
                <v-text-field
                  :error-messages="errors"
                  :disabled="true"
                  outlined
                  dense
                  :label="$t('landlord.companyName')"
                  v-model="requestModelObj.companyName"
                >
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" class="py-0">
              <ValidationProvider v-slot="{ errors }" rules="">
                <v-text-field
                  :error-messages="errors"
                  :disabled="true"
                  outlined
                  dense
                  :label="$t('landlord.address')"
                  type="text"
                  v-model="requestModelObj.addressLine1"
                >
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" class="py-0">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                  :error-messages="errors"
                  :disabled="true"
                  outlined
                  dense
                  :label="$t('landlord.requestedDate')"
                  type="text"
                  v-model="requestModelObj.requestedDate"
                >
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <!-- <v-col cols="12" sm="6" md="6" lg="6" class="py-0">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                  :error-messages="errors"
                  :disabled="true"
                  outlined
                  dense
                  :label="$t('customer.civilIdNumber')"
                  type="text"
                  v-model="requestModelObj.civilIdNumber"
                >
                </v-text-field>
              </ValidationProvider>
            </v-col> -->
            <!-- <v-col cols="12" sm="6" md="6" lg="6" class="py-3">
              <div>
                Commercial Licence Image
              </div>
              <v-img
                class=""
                :lazy-src="`
                  ${$store.getters.imageBaseUrl}/${requestModelObj.commercialLicenceImage}
                `"
                max-height="150"
                max-width="250"
                :src="`
                  ${$store.getters.imageBaseUrl}/${requestModelObj.commercialLicenceImage}
                  `"
              ></v-img>
              <div class="text-center">
                <v-btn icon color="info" @click="downloadFiles(requestModelObj.commercialLicenceImage)">
                  <v-icon>mdi-cloud-download</v-icon>
                </v-btn>
              </div>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" class="py-3">
              <div>
                Authorized Signatory Image
              </div>
              <v-img
                class=""
                :lazy-src="`
                  ${$store.getters.imageBaseUrl}/${requestModelObj.authorizedSignatoryImage}
                `"
                max-height="150"
                max-width="250"
                :src="`
                  ${$store.getters.imageBaseUrl}/${requestModelObj.authorizedSignatoryImage}
                  `"
              ></v-img>
              <div class="text-center">
                <v-btn icon color="info" @click="downloadFiles(requestModelObj.authorizedSignatoryImage)">
                  <v-icon>mdi-cloud-download</v-icon>
                </v-btn>
              </div>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" class="py-3">
              <div>
                CivilId Image Of Authorized Signatory
              </div>
              <v-img
                class=""
                :lazy-src="`
                  ${$store.getters.imageBaseUrl}/${requestModelObj.civilIdImageOfAuthorizedSignatory}
                `"
                max-height="150"
                max-width="250"
                :src="`
                  ${$store.getters.imageBaseUrl}/${requestModelObj.civilIdImageOfAuthorizedSignatory}
                  `"
              ></v-img>
              <div class="text-center">
                <v-btn icon color="info" @click="downloadFiles(requestModelObj.civilIdImageOfAuthorizedSignatory)">
                  <v-icon>mdi-cloud-download</v-icon>
                </v-btn>
              </div>
            </v-col> -->
            <!-- <v-col cols="12" sm="6" md="6" lg="6" class="py-3">
              <div>
                {{ $t('customer.civilIdImageBack') }}
              </div>
              <v-img
                class=""
                :lazy-src="`
                  ${$store.getters.imageBaseUrl}/${requestModelObj.civilIdImageBack}
                `"
                max-height="150"
                max-width="250"
                :src="`
                  ${$store.getters.imageBaseUrl}/${requestModelObj.civilIdImageBack}
                  `"
              ></v-img>
              <div class="text-center">
                <v-btn icon color="info" @click="downloadFiles(requestModelObj.civilIdImageBack)">
                  <v-icon>mdi-cloud-download</v-icon>
                </v-btn>
              </div>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" class="py-3">
              <div>
                {{ $t('customer.civilIdImageFront') }}
              </div>
              <v-img
                class=""
                :lazy-src="`
                  ${$store.getters.imageBaseUrl}/${requestModelObj.civilIdImageFront}
                `"
                max-height="150"
                max-width="250"
                :src="`
                  ${$store.getters.imageBaseUrl}/${requestModelObj.civilIdImageFront}
                  `"
              ></v-img>
              <div class="text-center">
                <v-btn icon color="info" @click="downloadFiles(requestModelObj.civilIdImageFront)">
                  <v-icon>mdi-cloud-download</v-icon>
                </v-btn>
              </div>
            </v-col> -->
            <!-- <v-col cols="12" sm="6" md="6" lg="6" class="py-0">
              <ValidationProvider v-slot="{ errors }">
                <v-text-field
                  :error-messages="errors"
                  :disabled="true"
                  outlined
                  dense
                  :label="$t('landlord.bankName')"
                  type="text"
                  v-model="requestModelObj.bankName"
                >
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" class="py-0">
              <ValidationProvider v-slot="{ errors }">
                <v-text-field
                  :error-messages="errors"
                  :disabled="true"
                  outlined
                  dense
                  :label="$t('landlord.iban')"
                  type="text"
                  v-model="requestModelObj.IBAN"
                >
                </v-text-field>
              </ValidationProvider>
            </v-col> -->
            <v-col
              v-if="requestModelObj.isEnquiry"
              cols="12"
              sm="6"
              md="6"
              lg="6"
              class="py-0"
            >
              <ValidationProvider
                v-slot="{ errors }"
                :rules="{ required: true, minPass: 6, maxPass: 20 }"
              >
                <v-text-field
                  v-model="requestModelObj.password"
                  :error-messages="errors"
                  outlined
                  dense
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("landlord.password") }}
                  </template></v-text-field
                >
              </ValidationProvider>
            </v-col>
            <v-col
              v-if="requestModelObj.isEnquiry"
              cols="12"
              sm="6"
              md="6"
              lg="6"
              class="py-0"
            >
              <ValidationProvider
                v-slot="{ errors }"
                :rules="{ sameAs: requestModelObj.password }"
              >
                <v-text-field
                  v-model="requestModelObj.confirmPassword"
                  :error-messages="errors"
                  outlined
                  dense
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("landlord.confirmPassword") }}
                  </template></v-text-field
                >
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" class="py-0">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-select
                  v-model="requestModelObj.commissionType"
                  :error-messages="errors"
                  outlined
                  dense
                  :items="commissionOptions"
                  item-text="text"
                  item-value="value"
                  :label="$t('landlord.commissionType')"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("landlord.commissionType") }}
                  </template></v-select
                >
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" class="py-0">
              <ValidationProvider
                v-slot="{ errors }"
                name="Commission"
                :rules="{ max: '6', required: true }"
              >
                <v-text-field
                  :error-messages="errors"
                  outlined
                  dense
                  :label="$t('landlord.commission')"
                  color="secondary"
                  type="number"
                  v-model="requestModelObj.commission"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("landlord.commission") }}
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="py-0">
              <ValidationProvider
                v-slot="{ errors }"
                :rules="
                  requestModelObj.status === 'VERIFIED'
                    ? { required: true }
                    : { required: false }
                "
              >
                <v-select
                  v-model="paymentTypes"
                  :error-messages="errors"
                  outlined
                  dense
                  multiple
                  color="white--text"
                  :items="paymentTypeOptions"
                  item-text="text"
                  item-value="value"
                  :label="$t('landlord.paymentType')"
                >
                  <template #label>
                    <span class="red--text"
                      ><strong
                        >{{ requestModelObj.status === "VERIFIED" ? "*" : " " }}
                      </strong></span
                    >{{ $t("landlord.paymentType") }}
                  </template></v-select
                >
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="py-0">
              <ValidationProvider
                v-slot="{ errors }"
                :rules="
                  requestModelObj.status === 'VERIFIED'
                    ? { required: true }
                    : { required: false }
                "
              >
                <v-select
                  :error-messages="errors"
                  v-model="validityPlan"
                  outlined
                  dense
                  :items="landlordValidityPlanLists"
                  item-text="planName"
                  item-value="_id"
                  :label="$t('settings.landlordValidityPlan.title')"
                >
                  <template #label>
                    <span class="red--text"
                      ><strong
                        >{{ requestModelObj.status === "VERIFIED" ? "*" : " " }}
                      </strong></span
                    >{{ $t("settings.landlordValidityPlan.title") }}
                  </template></v-select
                >
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="py-0">
              <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <ValidationProvider v-slot="{ errors }" rules="required">
                    <v-text-field
                      append-icon="mdi-calendar"
                      outlined
                      :error-messages="errors"
                      dense
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      disabled
                      :label="$t('landlord.endDate')"
                      color="secondary"
                      v-model="endDate"
                    >
                      <template #label>
                        <span class="red--text"><strong>* </strong></span
                        >{{ $t("landlord.endDate") }}
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </template>
                <v-date-picker
                  v-model="endDate"
                  @input="dateMenu = false"
                  :min="new Date().toISOString()"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" class="py-0">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-select
                  :error-messages="errors"
                  outlined
                  :items="['REQUESTED', 'VERIFIED', 'REJECTED', 'HOLD']"
                  dense
                  :label="$t('landlord.status')"
                  type="text"
                  v-model="requestModelObj.status"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("landlord.status") }}
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row justify="space-around">
            <v-col cols="4" sm="4" md="4" class="py-6">
              <!-- <div class="d-flex justify-space-around"> -->
              <v-btn
                width="100%"
                class="white--text"
                color="primary"
                @click="onCancel"
              >
                {{ $t("common.cancel") }}
              </v-btn>
            </v-col>
            <v-col cols="4" sm="4" md="4" class="py-6">
              <v-btn
                width="100%"
                class="white--text"
                color="primary"
                type="submit"
                :loading="btnLoading"
                >{{
                  isRequestLandlord ? $t("common.update") : $t("common.save")
                }}</v-btn
              >
              <!-- </div> -->
            </v-col>
            <v-col v-if="isError != null" cols="12" sm="12"
              ><Alert :message="isError" />
            </v-col>
          </v-row>
        </form>
      </ValidationObserver>
    </v-container>
  </div>
</template>
<script>
import "@/core/methods/validation_rules";
import { mapGetters } from "vuex";
import moment from "moment";
import { changeLandlordRequestStatus } from "../../methods/change_landlord_request_status";
import { createVerifiedLandlord } from "../../methods/create_landlord_admin";
import { formatDate } from "@/core/methods/formatDate";
// import { createLandlordRequest } from "../../methods/create_landlord_request";
export default {
  data() {
    return {
      btnLoading: false,
      endDate: null,
      isError: null,
      baseUrl: process.env.VUE_APP_BASE_URL,
      rerender: 0,
      commissionType: "",
      commission: "",
      paymentTypes: [],
      validityPlan: "",
      landlordValidityPlanLists: [],
      requestModelObj: {
        name: "",
        phone: "",
        email: "",
        address: "",
        status: "",
        password: "",
        commissionType: "",
        commission: "",
        companyName: ""
      }
    };
  },
  computed: {
    ...mapGetters(["isRequestLandlord", "editRequestLandlord"]),
    commissionOptions() {
      return [
        { value: "FIXED", text: this.$t("landlord.fixed") },
        { value: "PERCENTAGE", text: this.$t("landlord.percentage") }
      ];
    },
    paymentTypeOptions() {
      return [
        { value: "PAY_ONLINE", text: this.$t("landlord.payOnline") },
        { value: "PAY_AT_PROPERTY", text: this.$t("landlord.payAtProperty") }
      ];
    }
  },
  watch: {
    isRequestLandlord: {
      handler() {
        if (this.isRequestLandlord) {
          this.requestModelObj = this.$format.cloneVariable(
            this.editRequestLandlord
          );
          this.requestModelObj.requestedDate = this.dateFormat(
            new Date(parseInt(this.requestModelObj.requestedDate))
          );
        } else {
          this.requestModelObj = {
            name: "",
            address: "",
            email: "",
            phone: "",
            status: "",
            password: "",
            commissionType: "",
            commission: "",
            companyName: ""
          };
          this.reRender++;
        }
      },
      deep: true
    }
  },
  components: {
    Alert: () => import("@/core/components/Alert.vue")
  },
  mounted() {
    if (this.isRequestLandlord) {
      this.requestModelObj = this.$format.cloneVariable(
        this.editRequestLandlord
      );
      this.requestModelObj.requestedDate = this.dateFormat(
        new Date(parseInt(this.requestModelObj.requestedDate))
      );
    }
  },
  apollo: {
    getAllLandlordValidityPlan() {
      this.loading = true;
      return {
        query: require("@/settings/api/queries/landlord_validity_plan/get_all_landlord_validity_plan.graphql"),
        variables: {
          input: {
            limit: this.totalLandlordValidityPlan,
            skip: 0
          },
          filter: {
            searchKey: this.search
          }
        },
        result({ data, loading }) {
          // , loading, networkStatus, refetch
          this.landlordValidityPlanLists =
            data.getAllLandlordValidityPlan.landlordValidityPlans;
          this.loading = loading;
          this.totalLandlordValidityPlan =
            data.getAllLandlordValidityPlan.totalCount;
        }
      };
    },
    getLandlordValidityPlanById() {
      return {
        query: require("@/settings/api/queries/landlord_validity_plan/get_landlord_validity_plan_by_id.graphql"),
        variables() {
          return {
            id: this.validityPlan
          };
        },
        result({ data }) {
          this.validityDatails = data.getLandlordValidityPlanById;
          this.validity = data.getLandlordValidityPlanById.validity;
          this.changeValidity();
        },
        skip() {
          return !this.validityPlan;
        }
      };
    }
  },
  methods: {
    changeValidity() {
      if (this.validity) {
        this.endDate = formatDate(
          new Date().setDate(new Date().getDate() + this.validity)
        );
      }
    },
    downloadFiles(link) {
      const fileUrl = this.imageBaseUrl + "/" + link;
      var a = document.createElement("a");
      a.href = fileUrl;
      a.setAttribute("download", null);
      a.click();
    },
    dateFormat(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    statusOptions(staus) {
      if (staus !== "VERIFIED") return ["VERIFIED", "REJECTED", "HOLD"];
      else return ["REJECTED", "HOLD"];
    },
    async onSave() {
      this.btnLoading = true;
      const input = {
        landlordRequestId: this.requestModelObj._id,
        status: this.requestModelObj.status
      };
      changeLandlordRequestStatus(input).then(async data => {
        if (data.data.changeLandlordRequestStatus)
          this.$root.$emit("snackbar", {
            snackbar: true,
            text: this.$t("landlord.landlordStatus"),
            color: "green"
          });
        if (this.requestModelObj.status === "VERIFIED")
          await this.createVerifiedLandlord();
        this.btnLoading = false;
        this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
        this.$store.commit("IS_REQUEST_LANDLORD", false);
        this.$root.$emit("refetchLandlordRequest");
      });
      // const input = {
      //   name: this.name,
      //   phone: this.phone,
      //   email: this.email,
      //   address: this.address
      // }
      // this.btnLoading = true
      //   createLandlordRequest({ input: input }).then(response => {
      //     if (response.data) {
      //       this.btnLoading = false;
      //       this.$root.$emit('refetchLandlordRequest')
      //       this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
      //       this.$root.$emit("snackbar", {
      //         snackbar: true,
      //         text: this.$t("common.saveSuccess"),
      //         color: "green"
      //       });
      //       this.name = ''
      //       this.phone = ''
      //       this.email = ''
      //       this.address = ''
      //       this.rerender++
      //     }
      //     if (response.graphQLErrors) {
      //       this.btnLoading = false;
      //       this.isError = response.graphQLErrors[0].message;
      //       setTimeout(() => {
      //         this.isError = null
      //         }, 5000)
      //     }
      //   });
    },
    createVerifiedLandlord() {
      const input = {
        user: {
          firstName: this.requestModelObj.name,
          lastName: this.requestModelObj.lastName,
          phone: this.requestModelObj.phone,
          active: true,
          email: this.requestModelObj.email,
          password: this.requestModelObj.password
        },
        commissionType: this.requestModelObj.commissionType,
        commission: this.requestModelObj.commission,
        validityPlan: this.validityPlan,
        endDate: this.endDate,
        // civilIdNumber:this.requestModelObj.civilIdNumber,
        // civilIdImageBack:this.requestModelObj.civilIdImageBack,
        // civilIdImageFront:this.requestModelObj.civilIdImageFront,
        paymentTypes: this.paymentTypes,
        requestedId: this.requestModelObj._id
      };
      input.commission = Number(input.commission);
      createVerifiedLandlord(input).then(response => {
        if (response.data) {
          this.btnLoading = false;
          this.$root.$emit("refetchLandlord");
          this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
          this.$root.$emit("snackbar", {
            snackbar: true,
            text: this.$t("common.saveSuccess"),
            color: "green"
          });
        }
      });
    },
    onCancel() {
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
      this.$store.commit("IS_REQUEST_LANDLORD", false);
    },
    formatDate: formatDate
  }
};
</script>
<style scoped>
.numberClass >>> input[type="number"] {
  -moz-appearance: textfield;
}
.numberClass >>> input::-webkit-outer-spin-button,
.numberClass >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
</style>
